<template>
  <div class="add-test-dialog">
    <v-card>
      <v-card-title></v-card-title>
      <v-card-text>
        <v-container>
          <v-row no-gutters>
            <v-col>
              <div v-if="isEditing">
                <span class="headline" color="black">Edit Test Details</span>
                <p color="black">Subject: {{editData.subject.name}}</p>
              </div>

              <span class="headline" color="black" v-else>New Test Details</span>
            </v-col>
            <v-col class="align-right">
              <v-btn class="mb-2" @click="$emit('closeAddTestDialog')">Close</v-btn>
              <v-btn class="ml-2 mb-2" @click="submitForm">Save</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="formData.tname" label="Test Name" required></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                name="input-7-1"
                :dense="true"
                v-model="formData.description"
                label="Test Description"
                value
                rows="3"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-select
                :items="subjects"
                item-text="name"
                v-if="!isEditing"
                item-value="id"
                label="Subject"
                v-model="formData.selectedSubject"
                required
              >
                <template slot="selection" slot-scope="data">
                  <!-- HTML that describe how select should render selected items -->
                  {{ data.item.name }} - {{ data.item.room.name }}
                </template>
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item.name }} - {{ data.item.room.name }}
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-menu
                ref="menu"
                v-model="formData.datePicker.menu"
                :close-on-content-click="false"
                :return-value.sync="formData.datePicker.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.datePicker.date"
                    label="Select Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="(new Date()).toISOString()"
                  v-model="formData.datePicker.date"
                  no-title
                  scrollable
                >
                  <v-btn text color="primary" @click="formData.datePicker.menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(formData.datePicker.date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <v-menu
                ref="menu1"
                v-model="formData.timePicker.startTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="formData.timePicker.startTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.timePicker.startTime"
                    label="Start Time"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="formData.timePicker.startTimeMenu"
                  v-model="formData.timePicker.startTime"
                  full-width
                  @click:minute="$refs.menu1.save(formData.timePicker.startTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-menu
                ref="menu2"
                v-model="formData.timePicker.endTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="formData.timePicker.endTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.timePicker.endTime"
                    label="End Time"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="formData.timePicker.endTimeMenu"
                  v-model="formData.timePicker.endTime"
                  full-width
                  @click:minute="$refs.menu2.save(formData.timePicker.endTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="formErrors.isGenErrors">
      {{ formErrors.genErrors }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="formErrors.genErrors = null">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
// import testsApi from "@api/tests/all_tests";
import { mapActions, mapGetters } from "vuex";

import api from "@api/index";
import endpoints from "@api/repository";
import moment from "moment";

export default {
  name: "AddTest",
  props: ["isEditing", "editId"],
  data: () => ({
    moment: moment,
    editData: {
      subject: null,
    },
    formData: {
      tname: "",
      description: "",
      selectedSubject: null,
      dialog: false,
      datePicker: {
        date: new Date().toISOString().substr(0, 10),
        menu: false,
      },

      timePicker: {
        startTime: null,
        startTimeMenu: false,
        endTime: null,
        endTimeMenu: false,
      },
    },
    formErrors: {
      isGenErrors: false,
      genErrors: "",
      roomNotSelectedError: false,
      tname: "",
      description: "",
      date: "",
      startTime: "",
      endTime: "",
    },
    subjects: [],
  }),
  computed: {
    ...mapGetters(["currentUser", "isLoading", "accessToken", "adminRoom"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    // only called when editing
    async getTestDetails() {
      console.log("getting test details");
      var response;
      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: endpoints.getTestDetails + this.editId + "/",
        responseVar: response,
      });

      if (response) {
        console.log(response);
        this.formData.tname = response.tname;
        this.formData.description = response.description;
        this.editData.subject = response.subject;
        this.formData.datePicker.date = moment(response.start_datetime * 1000).format('YYYY-MM-DD');
        this.formData.timePicker.startTime = moment(response.start_datetime * 1000).format('HH:mm');
        this.formData.timePicker.endTime = moment(response.end_datetime * 1000).format('HH:mm');
      }
    },
    // get all subjects
    // if faculty: all faculty subjects, else if admin: SELECTED room subjects, else currentUser.room subjects
    async getAllSubjects() {
      var url = this.currentUser.is_admin
        ? endpoints.getSubjectsByRoom + this.adminRoom.room.id + "/"
        : endpoints.getFacultySubjects;
      var response;
      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        responseVar: response,
        url: url,
      });

      if (response) this.subjects = response;
    },

    validateFields() {
      this.formErrors.isGenErrors = false;
      var shouldSubmit = true;
      if (
        !this.formData.tname ||
        !this.formData.description ||
        !this.formData.datePicker.date ||
        !this.formData.timePicker.startTime ||
        !this.formData.timePicker.endTime ||
        (!this.formData.selectedSubject && !this.editData.subject)
      ) {
        shouldSubmit = false;
        this.formErrors.genErrors = "All fields are required";
        this.formErrors.isGenErrors = true;
      }

      return shouldSubmit;
    },
    // checks if date and time are valid
    validateDateTime(startDateTime, endDateTime) {
      var sdt = moment(startDateTime);
      var edt = moment(endDateTime);
      // if start is after end, throw error
      if (sdt.isAfter(edt)) {
        this.formErrors.genErrors = "Start time cannot be after End time.";
        this.formErrors.isGenErrors = true;
        return false;
      }

      if (sdt.isBefore(moment(new Date()))) {
        this.formErrors.genErrors = "Start time cannot be before current time.";
        this.formErrors.isGenErrors = true;
        return false;
      }

      return true;
    },

    async submitForm() {
      if (!this.validateFields()) return;
      // format datetime
      var startDateTime = new Date(
        `${this.formData.datePicker.date} ${this.formData.timePicker.startTime}`
      );
      var endDateTime = new Date(
        `${this.formData.datePicker.date} ${this.formData.timePicker.endTime}`
      );

      if (!this.validateDateTime(startDateTime, endDateTime)) return;

      var response;
      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: endpoints.createOrEditTest,
        method: api.Methods.POST,
        responseVar: response,
        body: {
          title: this.formData.tname,
          description: this.formData.description,
          start_datetime: Math.round(startDateTime.getTime() / 1000),
          end_datetime: Math.round(endDateTime.getTime() / 1000),
          subject_id: this.formData.selectedSubject ?? this.editData.subject.id,
          is_editing: this.isEditing ?? false,
          test_id: this.editId ?? null
        },
      });
      if (response) {
        this.$emit("closeAddTestDialog");
        this.$emit("refreshList");
      }
    },

    handleApiErrors(err) {
      console.log(err);
      this.setLoading(false);
    },
  },
  watch: {
    adminRoom() {
      this.selectedSubject = null;
      this.getAllSubjects();
      console.log("getting subjects again");
    },
  },

  async mounted() {
    if (this.isEditing) {
      // editing, retrieve test details
      this.getTestDetails();
    }
    await this.getAllSubjects();
  },
};
</script>

<style lang="css">
.align-right {
  text-align: end;
}
</style>